import { Directive, ElementRef, Renderer2, Input, TemplateRef, OnInit, HostListener, AfterViewInit, ComponentFactoryResolver, Injector, ApplicationRef, ChangeDetectorRef } from '@angular/core';
import { TooltipDirective } from '../../components/tooltip/tooltip.directive';
import { TooltipService } from './tooltip.service';

@Directive({
  selector: '[appEllipsisTooltip]',
  providers: [TooltipService],
})
export class EllipsisTooltipDirective extends TooltipDirective implements OnInit, AfterViewInit {
  @Input() appEllipsisTooltip: string | TemplateRef<unknown>;
  @Input() customTemplate: boolean;
  @Input() showHoverText: boolean;

  constructor(
    protected elementRef: ElementRef,
    componentFactoryResolver: ComponentFactoryResolver,
    injector: Injector,
    appRef: ApplicationRef,
    cdRef: ChangeDetectorRef,
    private renderer: Renderer2
  ) {
    super(elementRef, componentFactoryResolver, injector, appRef, cdRef);
    this.tooltipIndent = 4;
    this.tooltipMaxWidth = 200;
    this.tooltipTheme = 'white';
  }

  ngOnInit(): void {
  }
  ngAfterViewInit() {
    if (!this.showHoverText) {
     this.renderer.addClass(this.elementRef.nativeElement, 'ellipsis');
    }
  }

  private isEllipsisActive(element: HTMLElement): boolean {
    return element.offsetWidth < element.scrollWidth;
  }

  @HostListener('click', ['$event'])
  onClick() {
    super.hide();
  }

  @HostListener('mouseenter', ['$event'])
  onHover() {
    if (!this.tooltipIsDisabled) {
      if (this.showHoverText) {
        this.appTooltip = this.appEllipsisTooltip;
        this.tooltipMaxWidth = 300;
        super.show();
        return;
      }
      else {
        if (this.customTemplate) {
          this.appTooltip = this.appEllipsisTooltip;
          super.show();
          return;
        }
        this.appTooltip = this.isEllipsisActive(this.elementRef.nativeElement) ? this.elementRef.nativeElement.innerText : '';
        if (this.appTooltip) {
          super.show();
        }
      }
    }
  }
  @HostListener('mouseleave', ['$event'])
  onMouseOut() {
      super.hide();
  }
}
